export default __webpack_public_path__ + "static/3-c9ed0b5f5bc4d371664c3cfc129b3252.jpeg";